import Cookies from "js-cookie";
import { adminMainUrl } from "../../../Config";
import axios from "axios";


export const fetchTransportQuoteDetailRequest = () => ({
    type: "FIND_TRANSPORT_QUOTE_DETAIL_REQUEST",
});

export const fetchTransportQuoteDetailSuccess = (data) => ({
    type: "FIND_TRANSPORT_QUOTE_DETAIL_SUCCESS",
    payload: data,
});

export const fetchTransportQuoteDetailFailure = (error) => ({
    type: "FIND_TRANSPORT_QUOTE_DETAIL_FAILURE",
    payload: error,
});

export const getTransportQuoteDetail = (token, user_id, id) => {
    return async function (dispatch) {
        dispatch(fetchTransportQuoteDetailRequest());
        let config = {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'auth-token': token,
                'user_id': user_id
            },
            body: JSON.stringify({ quotation_id: id })
        };
        await fetch(`${adminMainUrl}/api/transport-quotation/view`, config)
            .then((res) => {
                res.json().then((resData) => {
                    dispatch(fetchTransportQuoteDetailSuccess(resData.data));
                })
            }).catch((err) => {
                dispatch(fetchTransportQuoteDetailFailure(err.message));
                console.log("ERROR in getTransportQuoteDetail function(redux):", err);
            });
    };
};




export const fetchTransportQuoteListRequest = () => ({
    type: "FIND_TRANSPORT_QUOTE_LIST_REQUEST",
});

export const fetchTransportQuoteListSuccess = (data) => ({
    type: "FIND_TRANSPORT_QUOTE_LIST_SUCCESS",
    payload: data,
});

export const fetchTransportQuoteListFailure = (error) => ({
    type: "FIND_TRANSPORT_QUOTE_LIST_FAILURE",
    payload: error,
});

export const getTransportQuoteList = (token, user_id, current_page, queryParams) => {
    return async function (dispatch) {
        dispatch(fetchTransportQuoteListRequest());

        let params = new URLSearchParams(queryParams);
        let requestBody = {
            request_no: "",
            name: "",
            email: "",
            phone: "",
            branch_id: "",
            pickup_date: "",
            delivery_date: ""
        };

        params.forEach((value, key) => {
            requestBody[key] = value;
        });
        params.delete('page');

        if (!current_page) {
            current_page = 1;
        }

        let config = {
            method: "POST", // Changed to POST to send payload
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(requestBody)
        };

        await fetch(`${adminMainUrl}/api/transport-quotation/list?page=${current_page}`, config)
            .then((res) => {
                res.json().then((resData) => {
                    dispatch(fetchTransportQuoteListSuccess(resData));
                })
            }).catch((err) => {
                dispatch(fetchTransportQuoteListFailure(err.message));
                console.log("ERROR in getTransportQuoteList function(redux):", err);
            });
    };
};



export const fetchTransporterListRequest = () => ({
    type: "FIND_TRANSPORTER_LIST_REQUEST",
});

export const fetchTransporterListSuccess = (data) => ({
    type: "FIND_TRANSPORTER_LIST_SUCCESS",
    payload: data,
});

export const fetchTransporterListFailure = (error) => ({
    type: "FIND_TRANSPORTER_LIST_FAILURE",
    payload: error,
});

export const getTransporterList = (token, user_id, current_page, queryParams) => {
    return async function (dispatch) {
        dispatch(fetchTransporterListRequest());

        let params = new URLSearchParams(queryParams);
        let requestBody = {
            company_name: "",
            email: "",
            phone_number: "",
            branch_id: "",
        };

        params.forEach((value, key) => {
            requestBody[key] = value;
        });
        params.delete('page');

        if (!current_page) {
            current_page = 1;
        }

        let config = {
            method: "POST", // Changed to POST to send payload
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(requestBody)
        };

        await fetch(`${adminMainUrl}/api/master/transporter/list?page=${current_page}`, config)
            .then((res) => {
                res.json().then((resData) => {
                    dispatch(fetchTransporterListSuccess(resData));
                })
            }).catch((err) => {
                dispatch(fetchTransporterListFailure(err.message));
                console.log("ERROR in getTransporterList function(redux):", err);
            });
    };
};


export const fetchTransporterDetailRequest = () => ({
    type: "FIND_TRANSPORTER_DETAIL_REQUEST",
});

export const fetchTransporterDetailSuccess = (data) => ({
    type: "FIND_TRANSPORTER_DETAIL_SUCCESS",
    payload: data,
});

export const fetchTransporterDetailFailure = (error) => ({
    type: "FIND_TRANSPORTER_DETAIL_FAILURE",
    payload: error,
});

export const getTransporterDetail = (token, user_id, id) => {
    return async function (dispatch) {
        dispatch(fetchTransporterDetailRequest());
        let config = {
            method: "GET",
            headers: {

                'auth-token': token,
                'user_id': user_id
            },

        };
        await fetch(`${adminMainUrl}/api/master/transporter/view?id=${id}`, config)
            .then((res) => {
                res.json().then((resData) => {
                    dispatch(fetchTransporterDetailSuccess(resData.data));
                })
            }).catch((err) => {
                dispatch(fetchTransporterDetailFailure(err.message));
                console.log("ERROR in getTransporterDetail function(redux):", err);
            });
    };
};



export const fetchTransporterWithoutListRequest = () => ({
    type: "FIND_TRANSPORTER_WITHOUT_LIST_REQUEST",
});

export const fetchTransporterWithoutListSuccess = (data) => ({
    type: "FIND_TRANSPORTER_WITHOUT_LIST_SUCCESS",
    payload: data,
});

export const fetchTransporterWithoutListFailure = (error) => ({
    type: "FIND_TRANSPORTER_WITHOUT_LIST_FAILURE",
    payload: error,
});

export const getTransporterWithoutList = (token, user_id) => {
    return async function (dispatch) {
        dispatch(fetchTransporterWithoutListRequest());
        let config = {
            method: "GET",
            headers: {

                'auth-token': token,
                'user_id': user_id
            },

        };
        await fetch(`${adminMainUrl}/api/master/transporter/list-without-perm`, config)
            .then((res) => {
                res.json().then((resData) => {
                    dispatch(fetchTransporterWithoutListSuccess(resData.data));
                })
            }).catch((err) => {
                dispatch(fetchTransporterWithoutListFailure(err.message));
                console.log("ERROR in getTransporterWithoutList function(redux):", err);
            });
    };
};



export const fetchDriverListRequest = () => ({
    type: "FIND_DRIVER_LIST_REQUEST",
});

export const fetchDriverListSuccess = (data) => ({
    type: "FIND_DRIVER_LIST_SUCCESS",
    payload: data,
});

export const fetchDriverListFailure = (error) => ({
    type: "FIND_DRIVER_LIST_FAILURE",
    payload: error,
});

export const getDriverList = (token, user_id, page, queryParams) => {
    return async function (dispatch) {
        dispatch(fetchDriverListRequest());

        let params = new URLSearchParams(queryParams);
        let requestBody = {
            name: "",
            email: "",
            phone_number: "",
            branch_id: "",
        };

        params.forEach((value, key) => {
            requestBody[key] = value;
        });
        params.delete('page');

        if (!page) {
            page = 1;
        }

        let config = {
            method: "POST", // Changed to POST to send payload
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(requestBody)
        };

        await fetch(`${adminMainUrl}/api/transport/driver/list?page=${page}`, config)
            .then((res) => {
                res.json().then((resData) => {
                    dispatch(fetchDriverListSuccess(resData));
                })
            }).catch((err) => {
                dispatch(fetchDriverListFailure(err.message));
                console.log("ERROR in getDriverList function(redux):", err);
            });
    };
};

export const fetchDriverDetailRequest = () => ({
    type: "FIND_DRIVER_DETAIL_REQUEST",
});

export const fetchDriverDetailSuccess = (data) => ({
    type: "FIND_DRIVER_DETAIL_SUCCESS",
    payload: data,
});

export const fetchDriverDetailFailure = (error) => ({
    type: "FIND_DRIVER_DETAIL_FAILURE",
    payload: error,
});

export const getDriverDetail = (token, user_id, id) => {
    return async function (dispatch) {
        dispatch(fetchDriverDetailRequest());
        let config = {
            method: "GET",
            headers: {

                'auth-token': token,
                'user_id': user_id
            },

        };
        await fetch(`${adminMainUrl}/api/transport/driver/view?id=${id}`, config)
            .then((res) => {
                res.json().then((resData) => {
                    dispatch(fetchDriverDetailSuccess(resData.data));
                })
            }).catch((err) => {
                dispatch(fetchDriverDetailFailure(err.message));
                console.log("ERROR in getDriverDetail function(redux):", err);
            });
    };
};


export const fetchDriverWithoutListRequest = () => ({
    type: "FIND_DRIVER_WITHOUT_LIST_REQUEST",
});

export const fetchDriverWithoutListSuccess = (data) => ({
    type: "FIND_DRIVER_WITHOUT_LIST_SUCCESS",
    payload: data,
});

export const fetchDriverWithoutListFailure = (error) => ({
    type: "FIND_DRIVER_WITHOUT_LIST_FAILURE",
    payload: error,
});

export const getDriverWithoutList = (token, user_id) => {
    return async function (dispatch) {
        dispatch(fetchDriverWithoutListRequest());
        let config = {
            method: "GET",
            headers: {

                'auth-token': token,
                'user_id': user_id
            },

        };
        await fetch(`${adminMainUrl}/api/transport/driver/list-without-perm`, config)
            .then((res) => {
                res.json().then((resData) => {
                    dispatch(fetchDriverWithoutListSuccess(resData.data));
                })
            }).catch((err) => {
                dispatch(fetchDriverWithoutListFailure(err.message));
                console.log("ERROR in getDriverWithoutList function(redux):", err);
            });
    };
};




export const fetchVehicleListRequest = () => ({
    type: "FIND_VEHICLE_LIST_REQUEST",
});

export const fetchVehicleListSuccess = (data) => ({
    type: "FIND_VEHICLE_LIST_SUCCESS",
    payload: data,
});

export const fetchVehicleListFailure = (error) => ({
    type: "FIND_VEHICLE_LIST_FAILURE",
    payload: error,
});

export const getVehicleList = (token, user_id, page, queryParams) => {
    return async function (dispatch) {
        dispatch(fetchVehicleListRequest());

        let params = new URLSearchParams(queryParams);
        let requestBody = {
            vehicle_id: "",
            vehicle_type: "",
            branch_id: "",
        };

        params.forEach((value, key) => {
            requestBody[key] = value;
        });

        params.delete('page');

        if (!page) {
            page = 1;
        }

        let config = {
            method: "POST", // Changed to POST to send payload
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(requestBody)
        };

        await fetch(`${adminMainUrl}/api/transport/vehicle/list?page=${page}`, config)
            .then((res) => {
                res.json().then((resData) => {
                    dispatch(fetchVehicleListSuccess(resData));
                })
            }).catch((err) => {
                dispatch(fetchVehicleListFailure(err.message));
                console.log("ERROR in getVehicleList function(redux):", err);
            });
    };
};

export const fetchVehicleDetailRequest = () => ({
    type: "FIND_VEHICLE_DETAIL_REQUEST",
});

export const fetchVehicleDetailSuccess = (data) => ({
    type: "FIND_VEHICLE_DETAIL_SUCCESS",
    payload: data,
});

export const fetchVehicleDetailFailure = (error) => ({
    type: "FIND_VEHICLE_DETAIL_FAILURE",
    payload: error,
});

export const getVehicleDetail = (token, user_id, id) => {
    return async function (dispatch) {
        dispatch(fetchVehicleDetailRequest());
        let config = {
            method: "GET",
            headers: {

                'auth-token': token,
                'user_id': user_id
            },

        };
        await fetch(`${adminMainUrl}/api/transport/vehicle/view?id=${id}`, config)
            .then((res) => {
                res.json().then((resData) => {
                    dispatch(fetchVehicleDetailSuccess(resData.data));
                })
            }).catch((err) => {
                dispatch(fetchVehicleDetailFailure(err.message));
                console.log("ERROR in getVehicleDetail function(redux):", err);
            });
    };
};

export const fetchVehicleWithoutListRequest = () => ({
    type: "FIND_VEHICLE_WITHOUT_LIST_REQUEST",
});

export const fetchVehicleWithoutListSuccess = (data) => ({
    type: "FIND_VEHICLE_WITHOUT_LIST_SUCCESS",
    payload: data,
});

export const fetchVehicleWithoutListFailure = (error) => ({
    type: "FIND_VEHICLE_WITHOUT_LIST_FAILURE",
    payload: error,
});

export const getVehicleWithoutList = (token, user_id) => {
    return async function (dispatch) {
        dispatch(fetchVehicleWithoutListRequest());
        let config = {
            method: "GET",
            headers: {

                'auth-token': token,
                'user_id': user_id
            },

        };
        await fetch(`${adminMainUrl}/api/transport/vehicle/list-without-perm`, config)
            .then((res) => {
                res.json().then((resData) => {
                    if (resData) {
                        console.log('action', resData?.data)
                        dispatch(fetchVehicleWithoutListSuccess(resData?.data));
                    }
                })
            }).catch((err) => {
                dispatch(fetchVehicleWithoutListFailure(err.message));
                console.log("ERROR in getVehicleWithoutList function(redux):", err);
            });
    };
};
